"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSystemConfig = getSystemConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 获取系统参数配置查询
function getSystemConfig() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/getSystemConfig',
    method: 'get'
  });
}